module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/layout/layout-top-panel-2-180fa13fe85c873af7996a6ebde31da3.svg";